import { render, staticRenderFns } from "./CollectionComplaint.vue?vue&type=template&id=bc2bc8b2&scoped=true"
import script from "./CollectionComplaint.vue?vue&type=script&lang=js"
export * from "./CollectionComplaint.vue?vue&type=script&lang=js"
import style0 from "./CollectionComplaint.vue?vue&type=style&index=0&id=bc2bc8b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2bc8b2",
  null
  
)

export default component.exports